type apiState = {
    user?: object
}

export default function apiReducer(state:apiState = {}, action) {
    const { type, error } = action;

    if (type.startsWith('FAIL_CREATE_TEST'))
    {
        alert(JSON.stringify(error));
        return {
            ...state,
            error: error,
        }
    }

    return state;
}